import {Component, Input} from '@angular/core';
import {WaterPointSvgComponent} from "src/app/presentation/common/icons/water-point-svg/water-point-svg.component";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";
import AssetSample = Samples.AssetSample;

@Component({
  selector: 'app-water-level-marker',
  imports: [
    WaterPointSvgComponent
  ],
  templateUrl: './water-level-marker.component.html',
  styleUrl: './water-level-marker.component.css'
})
export class WaterLevelMarkerComponent {

  @Input() iconName: string = ''
  @Input() percentage: string = ''
  @Input() name: string = ''
  @Input() lastAssetSample?: AssetSample<any>

}
